import { render, staticRenderFns } from "./TaxAssessmentWidget.vue?vue&type=template&id=9640112a&scoped=true&"
import script from "./TaxAssessmentWidget.vue?vue&type=script&lang=ts&"
export * from "./TaxAssessmentWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9640112a",
  null
  
)

export default component.exports